export var BUTTON_TEXT = {
  CANCEL: 'Cancel',
  COMPLETE_CITATION: 'Complete citation',
  UPDATE_CITATION: 'Update citation',
  BACK_TO_REVIEW: 'Back to review',
  BACK_TO_SEARCH: 'Back to search',
  BACK_TO_RESULTS: 'Back to results',
  BACK_TO_CITATION_LIST: 'Back to citation list'
};
export var TestIds;
(function (TestIds) {
  TestIds["CANCEL"] = "cancel-button-form-submission";
  TestIds["CREATE_CITATION"] = "create-citation-button-form";
  TestIds["UPDATE_CITATION"] = "update-citation-button-form";
  TestIds["FORM_SUBMIT_WRAPPER"] = "form-submit-wrapper";
})(TestIds || (TestIds = {}));